import Input from './Input'

const SearchField = props => {
  return (
    <Input
      {...props}
      autoComplete='on'
      variant='outlined'
      type='search'
      placeholder={'Start typing...'}
      className={props.className}
      inputRootSx={{
        boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.25)',
        height: 32
      }}
    />
  )
}

export default SearchField
